const moreBlock = () => {
	const moreItems = document.querySelectorAll('.wp-block-pushengage-theme-more-seo');

	if (!moreItems.length) {
		return;
	}

	moreItems.forEach((item) => {
		const toggleLinks = item.querySelectorAll('.am-more-seo__link');
		const openLink = item.querySelector('.am-more-seo__link');
		const moreContent = item.querySelector('.am-more-seo');

		toggleLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				moreContent.style.setProperty('--content-height', `${moreContent.scrollHeight}px`);
				item.classList.toggle('is-open');

				if (item.classList.contains('is-open')) {
					openLink.innerText = 'Show Less';
				} else {
					openLink.innerText = 'Read More';
				}
			});
		});
	});
};

export default moreBlock;